import { inject, observer } from "mobx-react";
import {
  fn_delivery_call,
  fn_show_accept_order_reject,
  fn_show_call,
  fn_show_hooking_order_cancel,
  fn_show_reject_order,
} from "function/FnBodyStep";
import {
  fn_layerCstView,
  fn_order_complete_layer,
  fn_order_payment_alert_show,
  fn_self_delivery_complet,
  fn_pos_order_complete_layer,
} from "function/FnBodyLayer";
import { fn_orderEndDetail } from "function/FnBodyDetail";
import {
  getDepositCheck,
  ygyMobileOrderFg,
  posOrdermMbileOrderFg,
  analyticeEvent,
  posOrderCallType,
} from "utils/Utils";
import { ygy_auto_cancel, fn_cooking_complete } from "http/StepConn";
import { fn_bridge_pos_order_call } from "function/FnPosBridge";
import { MobileOrderFg, StepCd } from "types";
import { isExpressDeliveryOrder, isHookingOrder, isRecallValidOrder } from "utils/CheckerOrderGroups";

const OrderCardButtonViewCase = ({ rootStore, order, searchStore }) => {
  const checkHooking = isHookingOrder(order);
  const checkDelivery = isExpressDeliveryOrder(order);
  const depositCk = getDepositCheck(order);
  let detailType = "";
  let showButton = true;
  let callType = posOrderCallType(rootStore, order);
  const checkRecall = isRecallValidOrder(order);

  const currStepType = searchStore.getCurrStepType;
  const { stepType, dlvStatusFg, stepCd } = order;
  if ((currStepType === "all" && stepType === "READY") || currStepType === "ready") {
    detailType = "ready";
  } else if ((currStepType === "all" && stepType === "COOKING") || currStepType === "cooking") {
    detailType = "cooking";
  } else if ((currStepType === "all" && stepType === "DELIVERY") || currStepType === "delivery") {
    if ((dlvStatusFg === null || dlvStatusFg === "99") && stepCd === StepCd.DELIVERY_REQUEST) {
      detailType = "cooking";
    } else {
      detailType = "delivery";
    }
  }

  function onClickActionBtnLeft() {
    if (posOrdermMbileOrderFg(order.mobileOrderFg)) {
      if (callType != "" && order.stepCd === StepCd.ACCEPTED) {
        //호출
        analyticeEvent("kdsPickupCall", "kdsPickupCallCard Button", "Button");
        fn_bridge_pos_order_call(rootStore, order, "", callType);
      } else if (order.stepCd === StepCd.PICKUP_REQUEST) {
        if (callType != "") {
          //재호출
          analyticeEvent("kdsPickupRecall", "kdsPickupRecallCard Button", "Button");
          fn_bridge_pos_order_call(rootStore, order, "", callType);
        } else {
          //주문취소
          if (order.mobileOrderFg === MobileOrderFg.TABLE_ORDER || order.mobileOrderFg === MobileOrderFg.QR_ORDER) {
            rootStore.layerStore.setLayerAlertType("okdcCancel");
            rootStore.layerStore.setLayerAlertView(true);
          } else {
            fn_show_accept_order_reject(rootStore, order.mobileOrderNo, "kdsOrderCancelCard Button");
          }
        }
      } else {
        //주문취소
        if (order.mobileOrderFg === MobileOrderFg.TABLE_ORDER || order.mobileOrderFg === MobileOrderFg.QR_ORDER) {
          rootStore.layerStore.setLayerAlertType("okdcCancel");
          rootStore.layerStore.setLayerAlertView(true);
        } else {
          fn_show_accept_order_reject(rootStore, order.mobileOrderNo, "kdsOrderCancelCard Button");
        }
      }
    } else {
      if (detailType === "cooking") {
        if (
          order.orderType === "PICKUP" &&
          order.partnerType === "CID" &&
          depositCk === false &&
          order.payType != "PAID"
        ) {
          fn_order_payment_alert_show(rootStore, order.mobileOrderNo, "orderPickupCompleteList Button");
        } else {
          checkHooking
            ? fn_show_hooking_order_cancel(rootStore, order.mobileOrderNo, "orderCancelCard Button")
            : fn_show_call(rootStore, order.mobileOrderNo);
        }
      } else if (detailType === "delivery") {
        if (checkRecall) {
          fn_show_call(rootStore, order.mobileOrderNo);
        } else {
          //fn_recall(rootStore, order.mobileOrderNo) 재호출
          ygyMobileOrderFg(order.mobileOrderFg) ||
          order.mobileOrderFg === MobileOrderFg.WMPO ||
          order.mobileOrderFg === MobileOrderFg.DDANGYO ||
          order.mobileOrderFg === MobileOrderFg.BMSMILE ||
          order.mobileOrderFg === MobileOrderFg.MUKKEBI
            ? fn_show_reject_order(rootStore, order.mobileOrderNo, "C")
            : fn_show_accept_order_reject(rootStore, order.mobileOrderNo, "orderCancelDetail Button");
        }
      }
    }
  }

  function onClickActionBtnRight() {
    if (posOrdermMbileOrderFg(order.mobileOrderFg)) {
      analyticeEvent("kdsOrderPickupComplete", "orderPickupCompleteCard Button", "Button");
      fn_pos_order_complete_layer(rootStore, order);
    } else {
      if (detailType === "ready") {
        ygyMobileOrderFg(order.mobileOrderFg)
          ? ygy_auto_cancel(rootStore, order.mobileOrderNo, order.mobileOrderFg, order.morderTypeCd)
          : fn_layerCstView(rootStore, order.mobileOrderNo, "orderAcceptCard Button");
      } else if (detailType === "cooking") {
        if (order.orderType === "DELIVERY") {
          checkDelivery
            ? order.gstPayAmt != 0
              ? fn_order_complete_layer(rootStore, order.mobileOrderNo, "orderCompleteCard Button")
              : fn_self_delivery_complet(rootStore, true, order.mobileOrderNo, "orderCompleteCard Button")
            : fn_delivery_call(rootStore, order.mobileOrderNo, "riderCallCard Button");
        } else if (order.orderType === "PICKUP") {
          fn_order_complete_layer(rootStore, order.mobileOrderNo, "orderPickupCompleteCard Button");
        } else {
          checkHooking || (order.orderType === "TABLE" && order.mobileOrderFg == "27")
            ? depositCk === true
              ? fn_order_complete_layer(rootStore, order.mobileOrderNo, "orderPickupCompleteCard Button")
              : fn_order_payment_alert_show(rootStore, order.mobileOrderNo, "orderPickupCompleteCard Button")
            : fn_show_call(rootStore, order.mobileOrderNo);
        }
      } else if (detailType === "delivery") {
        if (order.orderType === "DELIVERY") {
          //요기요 조리완료(픽업중)
          if (order.mobileOrderFg == "31" && (order.dlvStatusFg == "00" || order.dlvStatusFg == "02")) {
            fn_cooking_complete(rootStore, order);
          } else {
            order.gstPayAmt != 0
              ? fn_order_complete_layer(rootStore, order.mobileOrderNo, "orderCompleteCard Button")
              : fn_self_delivery_complet(rootStore, true, order.mobileOrderNo, "orderCompleteCard Button");
          }
        } else {
          depositCk === true
            ? fn_order_complete_layer(rootStore, order.mobileOrderNo, "orderPickupCompleteCard Button")
            : fn_order_payment_alert_show(rootStore, order.mobileOrderNo, "orderPickupCompleteCard Button");
        }
      } else if (order.stepCd === StepCd.ORDER_COMPLETED || order.stepCd === StepCd.ORDER_CANCELLED) {
        fn_orderEndDetail(rootStore, order.mobileOrderNo, "endOrderView");
      }
    }
  }

  function getLeftButtonConfig() {
    let txt = "";
    let cls = "c";
    if (order.stepCd === StepCd.ORDER_COMPLETED || order.stepCd === StepCd.ORDER_CANCELLED) {
      showButton = false;
      return;
    }

    if (posOrdermMbileOrderFg(order.mobileOrderFg)) {
      if (!callType) {
        showButton = false;
        return;
      }
      if (order.stepCd === StepCd.ACCEPTED) {
        cls = "s";
        txt = "호출";
      } else {
        cls = "s";
        txt = "재호출";
      }
    } else {
      if (detailType === "ready") {
        showButton = false;
      } else if (detailType === "cooking") {
        if (!!callType && order.stepCd === StepCd.PICKUP_REQUEST) {
          txt = "재호출";
        } else if (order.orderType === "PICKUP") {
          cls = "s";
          if (order.partnerType === "CID") {
            if (depositCk === false && order.payType !== "PAID") {
              txt = "픽업결제";
            } else {
              showButton = false;
            }
          } else if (!checkHooking) {
            txt = "호출";
          } else {
            showButton = false;
          }
        } else if (order.orderType === "DELIVERY") {
          showButton = false;
        } else {
          cls = "s";
          txt = "호출";
        }
      } else if (detailType === "delivery") {
        if (order.orderType === "DELIVERY") {
          showButton = false;
        } else {
          if (checkRecall) {
            cls = "s";
            txt = "재호출";
          } else {
            showButton = false;
          }
        }
      }
    }

    if (showButton) {
      return (
        <span>
          <button type="button" className={cls} onClick={() => onClickActionBtnLeft()}>
            {txt}
          </button>
        </span>
      );
    }
  }

  function btnTypeTxtRight() {
    const { mobileOrderFg, dlvStatusFg, orderType } = order;

    if (posOrdermMbileOrderFg(mobileOrderFg)) {
      return "픽업완료";
    }

    if (detailType === "ready") {
      return "주문접수";
    }

    if (detailType === "cooking") {
      if (orderType === "DELIVERY") {
        return checkDelivery ? "배달완료" : "배달요청";
      }
      return "픽업완료";
    }

    if (detailType === "delivery") {
      if (orderType === "DELIVERY") {
        return mobileOrderFg === MobileOrderFg.YOGIYO_EXPRESS && ["00", "02"].includes(dlvStatusFg)
          ? "조리완료"
          : "배달완료";
      }
      return "픽업완료";
    }
    return "";
  }

  function getButtonColor() {
    const { stepCd, mobileOrderFg, orderType, dlvStatusFg } = order;
    // 포스, 키오스크, 테이블, QR 주문 선 체크크
    if (posOrdermMbileOrderFg(mobileOrderFg)) {
      if (stepCd === StepCd.ORDER_COMPLETED) return "end";
      if (stepCd === StepCd.ORDER_CANCELLED) return "cancel";
      return "complete";
    }

    // 주문 수락 전
    if (detailType === "ready") {
      return "s";
    }

    // 주문 수락 및 조리 중
    if (detailType === "cooking") {
      if (orderType === "DELIVERY") {
        return checkDelivery ? "complete" : "s";
      }
      return "complete";
    }

    // 조리 끝 배달 요청
    if (detailType === "delivery") {
      if (orderType === "DELIVERY") {
        return mobileOrderFg === MobileOrderFg.YOGIYO_EXPRESS && ["00", "02"].includes(dlvStatusFg) ? "s" : "complete";
      }
      return "complete";
    }

    // 주문 완료 및 취소
    if (stepCd === StepCd.ORDER_COMPLETED) return "end";
    if (stepCd === StepCd.ORDER_CANCELLED) return "cancel";

    return "";
  }

  function btnEnd() {
    if (order.stepCd === StepCd.ORDER_COMPLETED) return "완료주문";
    if (order.stepCd === StepCd.ORDER_CANCELLED) return "취소주문";
    return "";
  }

  return (
    <span className="btns">
      <span className="inner">
        {getLeftButtonConfig()}
        <span>
          <button type="button" className={getButtonColor()} onClick={() => onClickActionBtnRight()}>
            {order.stepCd === StepCd.ORDER_COMPLETED || order.stepCd === StepCd.ORDER_CANCELLED ? (
              <span className="btn_end">{btnEnd()}</span>
            ) : (
              btnTypeTxtRight()
            )}
          </button>
        </span>
      </span>
    </span>
  );
};

export default inject("rootStore")(observer(OrderCardButtonViewCase));
